import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

/**
 * Hook to invalidate API tokens query.
 * Use this after creating, updating, or revoking API tokens.
 */
export const useInvalidateApiTokens = () => {
  const queryClient = useQueryClient();

  return useCallback(async () => {
    await queryClient.invalidateQueries({
      queryKey: ["useApiTokensQuery"]
    });
  }, [queryClient]);
};
